import React from 'react';
import PropTypes from 'prop-types';
import './AddLienReleaseForm.css';
import uploadSvg from 'images/upload.svg';
import Dropzone from 'react-dropzone';
import DocumentLink from 'components/shared/document/DocumentLink';

export default function AddLienReleaseForm(props) {
  const handleDocumentDrop = (files) => {
    if (props.onDocumentDrop) {
      props.onDocumentDrop(files[0]);
    }
  };

  let fileComponent = null;
  if (props.fileUrl === null) {
    fileComponent = (
      <Dropzone
        accept="application/pdf, .doc, .docx, .xls, .xlsx"
        className="dropzone-container"
        multiple={false}
        onDrop={handleDocumentDrop}
      >
        <span>Please drag and drop any file into this area</span>
        <img src={uploadSvg} alt="upload" />
      </Dropzone>
    );
  } else {
    fileComponent = (
      <div className="file-viewer">
        <DocumentLink showIcon={false} showLink={true} url={props.fileUrl} />
      </div>
    );
  }
  return (
    <div className="add-lien-release-form">
      <table>
        <colgroup>
          <col />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td>Document</td>
            <td>{fileComponent}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

AddLienReleaseForm.propTypes = {
  fileUrl: PropTypes.string,
  onDocumentDrop: PropTypes.func,
};

AddLienReleaseForm.defaultProps = {
  fileUrl: null,
};



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/contractors-lien-releases/AddLienReleaseForm.js